import React, { useContext } from 'react'

import White from './white-logo.svg'
import Black from './black-logo.svg'
import WhiteAlt from './white-alt-logo.svg'
import BlackAlt from './black-alt-logo.svg'

import { ColorModeContext } from 'layouts/color-mode'
import { useNavigate } from 'react-router-dom'

const Variants = {
  0: White,
  1: Black,
  2: WhiteAlt,
  3: BlackAlt
}

export function FSXLogo ({
  height = '50px',
  variant = 0,
  alt = '',
  title = ''
}) {
  const Logo = Variants[variant]
  const navigate = useNavigate()
  const clickHandler = () => navigate('/')

  return (
    <img
      alt={alt}
      title={title}
      height={height}
      style={{
        cursor: 'pointer'
      }}
      src={Logo}
      onClick={clickHandler}
    />
  )
}

export function ColorModeLogo ({
  height = 50,
  alt = '',
  title = ''
}) {
  const colorMode = useContext(ColorModeContext);
  const logoVariant = colorMode.mode === 'dark' ? 2 : 3;

  return (
    <FSXLogo
      height={height}
      variant={logoVariant}
      alt={alt}
      title={title}
    />
  )
}

export default FSXLogo
